var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExtractorHood = function SvgExtractorHood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.2,
    height: 26.043
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2a4d4f",
    stroke: "#2a4d4f",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3998",
    d: "M21.053 13.489c-.052-.107.333.492-5.17-7.71V.504a.4.4 0 0 0-.4-.4h-9.77a.4.4 0 0 0-.4.4v5.287L.175 13.442a.419.419 0 0 0-.069.225v4.385a.4.4 0 0 0 .4.4h20.19a.4.4 0 0 0 .4-.4v-4.385a.41.41 0 0 0-.046-.178ZM6.114 5.496V3.605h8.963v1.89ZM15.077.907v1.89H6.114V.907Zm-9.142 5.4h9.328l4.673 6.959H1.261Zm14.356 11.34H.907V14.07h19.385Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3999",
    d: "M8.672 6.898H6.466a.4.4 0 0 0-.335.178l-1.42 2.115a.4.4 0 0 0 .11.561.4.4 0 0 0 .56-.11l1.3-1.936h1.991a.404.404 0 0 0 0-.808Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4000",
    d: "M18.117 17.144a1.286 1.286 0 1 0-1.286-1.286 1.288 1.288 0 0 0 1.286 1.286Zm0-1.764a.48.48 0 0 1 .479.479.473.473 0 0 1-.479.478.478.478 0 0 1 0-.957Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4001",
    d: "M15.016 17.144a1.286 1.286 0 1 0-1.286-1.286 1.288 1.288 0 0 0 1.286 1.286Zm0-1.764a.48.48 0 0 1 .479.479.473.473 0 0 1-.479.478.478.478 0 0 1 0-.957Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4002",
    d: "M11.917 17.144a1.286 1.286 0 1 0-1.286-1.286 1.288 1.288 0 0 0 1.286 1.286Zm0-1.764a.479.479 0 0 1 .478.479.473.473 0 0 1-.478.478.478.478 0 1 1 0-.957Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4003",
    d: "M2.199 16.263h.966a.404.404 0 1 0 0-.808h-.966a.404.404 0 1 0 0 .808Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4004",
    d: "M4.522 16.263h.966a.404.404 0 1 0 0-.808h-.966a.404.404 0 1 0 0 .808Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4005",
    d: "M6.845 16.263h.966a.404.404 0 1 0 0-.808h-.966a.404.404 0 1 0 0 .808Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4006",
    d: "M4.752 21.513a2.743 2.743 0 0 1 .453-.976.404.404 0 1 0-.654-.473 3.533 3.533 0 0 0-.584 1.265c-.259 1.1.409 1.6.694 2.245a1.566 1.566 0 0 1-.319 1.688.402.402 0 1 0 .58.558 2.381 2.381 0 0 0 .472-2.57c-.334-.764-.817-1.01-.646-1.735Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4007",
    d: "M8.654 21.517a2.729 2.729 0 0 1 .453-.975.404.404 0 0 0-.653-.475 3.533 3.533 0 0 0-.584 1.265c-.259 1.1.41 1.6.694 2.245a1.57 1.57 0 0 1-.319 1.688.403.403 0 0 0 .584.556 2.383 2.383 0 0 0 .472-2.57c-.324-.737-.816-1.02-.648-1.735Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4008",
    d: "M12.556 21.517a2.729 2.729 0 0 1 .453-.975.404.404 0 0 0-.653-.475 3.533 3.533 0 0 0-.584 1.265c-.261 1.109.4 1.566.694 2.245a1.566 1.566 0 0 1-.319 1.688.403.403 0 1 0 .584.556 2.381 2.381 0 0 0 .472-2.57c-.334-.759-.818-1.013-.648-1.735Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4009",
    d: "M16.457 21.513a2.742 2.742 0 0 1 .453-.976.404.404 0 1 0-.654-.473 3.537 3.537 0 0 0-.584 1.264c-.262 1.1.41 1.6.693 2.246a1.566 1.566 0 0 1-.319 1.688.403.403 0 0 0 .584.556 2.381 2.381 0 0 0 .472-2.57c-.333-.762-.816-1.012-.645-1.735Z"
  }))));
};
export default SvgExtractorHood;